import ToolTip from "./ToolTip";
import type { ToolTipPosition, ToolTipContent, ToolTipProps } from "./ToolTip";
export default ToolTip;
export type { ToolTipPosition, ToolTipContent, ToolTipProps };
